import React from 'react';

import i18n from '@i18n';
import { Slide } from '@/swipeable/Slide';
import SwipeableViews from 'react-swipeable-views';
import { fireGAEvent } from '@/analytics';
import { vhSportIconMap, vhSports } from '../services/vh-service';
import { VIRTUAL_GAMES } from '@/routing/routes';
import { navigate } from '@/routing';

const VhModuleSlider = React.memo(function VhModuleSlider() {
    function handleClick(sportId, sportName) {
        fireGAEvent('Virtual games module - ponuka', 'Virtual Games Module - Ponuka', 'Virtual game ' + { sportName });
        navigate(VIRTUAL_GAMES, { sportSlugPart: sportName });
    }

    function vgSubtitle(sportId) {
        switch (sportId) {
            case 128:
                return i18n('virtual.modul.msg.dostihy');
            case 129:
                return i18n('virtual.modul.msg.tenis');
            case 130:
                return i18n('virtual.modul.msg.cyklistika');
            case 131:
                return i18n('virtual.modul.msg.futbal');
            case 132:
                return i18n('virtual.modul.msg.motorizmus');
            default:
                return i18n('virtual.modul.msg.default');
        }
    }

    return (
        <div className="vh-module-slider swipeable-views">
            <div className="primary-wrap">
                <div className="module-title-box">
                    <h1>{i18n('nikeOne.virtual')}</h1>
                </div>
                <h3 className="shade shade-line-2">{i18n('virtual.games.module.msg')}</h3>
            </div>
            <SwipeableViews slideClassName="slide-wrap" className="swiper" resistance>
                {vhSports
                    .sort(() => {
                        return 0.5 - Math.random();
                    })
                    .map(sport => (
                        <Slide key={sport.id}>
                            <div className="vh-module-item-box" onClick={() => handleClick(sport.id, sport.name)}>
                                <div className="vh-module-item-icon">
                                    <div className={'sport-icon-standard icon-' + vhSportIconMap[sport.id]} />
                                </div>
                                <div className="vh-module-item-text shade shade-line-2">{vgSubtitle(sport.id)}</div>
                            </div>
                        </Slide>
                    ))}
            </SwipeableViews>
        </div>
    );
});

export default VhModuleSlider;
